<script>
    import Vue from 'vue';
    import VueCroppie from 'vue-croppie';
    import VueButton from '~/components/button/components/button';
    import ImageCropDialog from './image_crop_dialog';
    import Loader from '~/components/loader/components/loader';
    import { Dialog, Upload, Message } from 'element-ui';

    Vue.use(VueCroppie);
    Vue.use(Dialog);
    Vue.use(Upload);

    export default {
        name: "image-crop",

        components: {
            Loader,
            VueButton,
            ImageCropDialog
        },

        data() {
            return {
                modalLoading: true,
                file: null,
                url: this.defaultImage,
                cropperVisible: false
            }
        },

        props: {
            value: {
                required: true
            },

            cropModalVisible: {
                required: true
            },

            type: {
                type: String,
                default: 'base64'
            },

            format: {
                type: String,
                default: 'jpeg, jpg, png, gif'
            },

            circle: {
                type: Boolean,
                default: false
            },

            allowCrop: {
                type: Boolean,
                default: true
            },

            cropDialogTitle: {
                type: String,
                default: 'Image Cropper'
            },

            useCroppie: {
                type: Boolean,
                default: true
            },

            defaultImage: {
                type: String,
                default: ''
            },

            viewport: {
                type: Object,
                default() {
                    return {
                        width: 200,
                        height: 300,
                        type: 'square'
                    }
                }
            },

            boundary: {
                type: Object,
                default() {
                    return {
                        width: 400,
                        height: 400
                    }
                }
            }
        },

        watch: {
            cropModalVisible(val) {
                if(!val){
                    return;
                }

                if(!this.file && this.defaultImage) {
                    this.modalLoading = true;
                    this.readRemoteImageAsBlob(this.defaultImage)
                    .then(response => {
                        this.url = response.data_url;
                        this.cropperVisible = true;
                        this.modalLoading = false;
                    })
                    .catch(xhr => {
                        this.modalLoading = false;
                        Message({
                            message: 'Unable to load image',
                            type: 'error'
                        });
                    });
                } else {
                    let reader = new FileReader();
                    this.modalLoading = true;
                    reader.readAsDataURL(this.file.raw);
                    reader.onload = () => {
                        this.url = reader.result;
                        this.modalLoading = false;
                        this.cropperVisible = true;
                    };
                    reader.onerror = (error) => {
                        this.modalLoading = false;
                    };
                }
            },
            cropperVisible(val) {
                this.$emit('update:cropModalVisible', val);
            }
        },

        methods: {
            fileChange(file) {
                this.file = file;
                this.$emit('change', file);
            },

            input(value) {
                this.$emit('input', value);
            },

            readRemoteImageAsBlob(imageUrl){
                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: '/register/image-data',
                        data: {
                            url: imageUrl
                        },
                        method: 'GET',
                        global: false,
                        cache: false
                    })
                    .done((response) => {
                        resolve(response);
                    })
                    .fail((xhr) => {
                        reject(xhr);
                    });
                });
            }
        }
    };
</script>

<template>
    <div>
        <el-upload
            action="#"
            accept=".jpg, .png, .gif"
            class="upload-cropper"
            :auto-upload="false"
            :limit="1"
            :show-file-list="false"
            :on-change="fileChange"
        >
            <vue-button
                type="primary"
                size="md"
            >
                <i class="el-icon-upload"></i> &nbsp;Click to upload
            </vue-button>
        </el-upload>
        <image-crop-dialog
            ref="imageCropperDialog"
            :title="cropDialogTitle"
            :type="type"
            :format="format"
            :circle="circle"
            :viewport="viewport"
            :boundary="boundary"
            :allow-crop="allowCrop"
            :use-croppie="useCroppie"
            :static-image-src="url"
            :cropperVisible.sync="cropperVisible"
            :url.sync="url"
            :modalLoading.sync="modalLoading"
            @input="input">
        </image-crop-dialog>
    </div>
</template>